import { useState } from "react";
import { Navigate, Link } from "react-router-dom";
import { LogOut, Inbox, Briefcase, Users } from "lucide-react";
import { Logo } from "@/components/Logo";
import { useAuth } from "@/lib/auth";
import { EnquiriesPanel } from "@/components/admin/EnquiriesPanel";
import { JobsPanel } from "@/components/admin/JobsPanel";
import { ApplicationsPanel } from "@/components/admin/ApplicationsPanel";

const TABS = [
  { id: "enquiries", label: "Enquiries", icon: Inbox, Panel: EnquiriesPanel },
  { id: "jobs", label: "Job postings", icon: Briefcase, Panel: JobsPanel },
  { id: "applications", label: "Applications", icon: Users, Panel: ApplicationsPanel },
];

export default function AdminDashboard() {
  const { user, logout } = useAuth();
  const [tab, setTab] = useState("enquiries");

  if (user === null) return <div className="grid min-h-screen place-items-center bg-brand-ice font-mono text-xs uppercase tracking-[0.3em] text-brand-indigo">Loading…</div>;
  if (user === false) return <Navigate to="/admin/login" replace />;

  const Panel = TABS.find((t) => t.id === tab).Panel;

  return (
    <div data-testid="admin-dashboard" className="min-h-screen bg-brand-ice">
      <header className="border-b border-brand-indigo/10 bg-white">
        <div className="mx-auto flex max-w-[1200px] items-center justify-between px-6 py-4">
          <Link to="/" data-testid="admin-home-link"><Logo testId="admin-logo" /></Link>
          <div className="flex items-center gap-4">
            <Link to="/brand" data-testid="admin-brand-kit-link" className="hidden text-xs font-semibold text-brand-indigo hover:underline sm:inline">Logo kit</Link>
            <span data-testid="admin-user-email" className="hidden font-mono text-[11px] text-brand-ink/60 sm:inline">{user.email}</span>
            <button data-testid="admin-logout" onClick={logout} className="inline-flex items-center gap-2 rounded-full border border-brand-indigo/20 px-4 py-2 text-xs font-semibold text-brand-indigo transition hover:bg-brand-ice"><LogOut className="h-3.5 w-3.5" />Sign out</button>
          </div>
        </div>
      </header>

      <main className="mx-auto max-w-[1200px] px-6 py-10">
        <div className="font-mono text-[11px] uppercase tracking-[0.3em] text-brand-indigo">Private · Malansh team</div>
        <nav data-testid="admin-tabs" className="mt-4 flex flex-wrap gap-2 border-b border-brand-indigo/10">
          {TABS.map(({ id, label, icon: Icon }) => (
            <button key={id} data-testid={`admin-tab-${id}`} onClick={() => setTab(id)} className={`-mb-px inline-flex items-center gap-2 border-b-2 px-4 py-3 text-sm font-semibold transition ${tab === id ? "border-brand-indigo text-brand-indigo" : "border-transparent text-brand-ink/50 hover:text-brand-ink"}`}>
              <Icon className="h-4 w-4" />{label}
            </button>
          ))}
        </nav>
        <div className="mt-8"><Panel key={tab} /></div>
      </main>
    </div>
  );
}
